(function ($) {
    $('.hero-with-navigation-links-mobile .navigation-header').on('click', function() {
        const parent = $(this).closest('.hero-with-navigation-links-mobile');
        const nav = parent.find('ul');

        parent.toggleClass('active');
        nav.slideToggle();
    });

    $('.single-home-hero-with-navigation-links-mobile .navigation-header').on('click', function() {
        const parent = $(this).closest('.single-home-hero-with-navigation-links-mobile');
        const nav = parent.find('ul');

        parent.toggleClass('active');
        nav.slideToggle();
    });

    $('.home-navigation-mobile .navigation-header .toggle-nav').on('click', function() {
        const parent = $(this).closest('.home-navigation-mobile');
        const nav = parent.find('ul');

        parent.toggleClass('active');
        nav.slideToggle();
    });

    if ($('.single-home').length && $('.home-navigation').length) {
        $(window).on('scroll', function() {
            if ($('.home-navigation')[0].getBoundingClientRect().bottom - 20 <= 0) {
                $('.home-navigation-sticky').addClass('active');
            } else {
                $('.home-navigation-sticky').removeClass('active');
            }
        });
    }

    /**
     * Hide icon if menu is scrolled
     */
    $( '.c-mobile-navigation-list' ).on( 'scroll', function(e) {
        var ppScrollLeft = e.currentTarget.scrollLeft;
        if ( ppScrollLeft > 20 ) {
            $(this).parent().addClass('js-hide-icon');    
        } else if ( ppScrollLeft < 20 ) {
            $(this).parent().removeClass('js-hide-icon');    
        }
    } );

    /**
     * Set scrollLeft for menu
     */
    var horizontalMenuActiveItem = $('#scroll-menu-mobile').find('li.active');
    if ( horizontalMenuActiveItem.length > 0 ) {
        var horizontalActivePositionLeft = horizontalMenuActiveItem.position().left;
        var horizontalNewPosition = Math.round( horizontalActivePositionLeft - 8 );
        
        document.getElementById("scroll-menu-mobile").scrollLeft = horizontalNewPosition;
    }

})(jQuery);